__webpack_require__.p = "https://dev2-jericho.twelfthman.co/brand/";